import { render, staticRenderFns } from "./myArticle.vue?vue&type=template&id=4146453d&scoped=true&"
import script from "./myArticle.vue?vue&type=script&lang=js&"
export * from "./myArticle.vue?vue&type=script&lang=js&"
import style0 from "./myArticle.vue?vue&type=style&index=0&id=4146453d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4146453d",
  null
  
)

export default component.exports